import styled, { css } from 'styled-components';
import { defaultTheme } from '@styles/theme.styled';
import { generateScales } from '@helpers/generate-media-queries';

interface ContainerProps {
  $hasBorder?: boolean;
}

export const Container = styled.div<ContainerProps>`
  ${({ theme, $hasBorder }) => css`
    padding: 0;
    padding-top: ${$hasBorder ? '1rem' : '0'};
    width: 100%;
    border-top: ${$hasBorder ? `1px solid ${theme.colors.dark}33` : 'none'};
  `}
`;

export const Title = styled.p<{ textColor: keyof typeof defaultTheme.colors }>`
  ${({ theme, textColor }) => css`
    ${generateScales(
      'font-size',
      theme.fontSize.extraSmall.mobile,
      theme.fontSize.extraSmall.desktop,
      theme
    )}
    line-height: 1;
    font-weight: 500;
    text-transform: uppercase;
    color: ${theme.colors[textColor]};
    opacity: 0.75;
    margin-bottom: 0.5rem;
  `}
`;

export const Media = styled.div`
  display: flex;
  column-gap: 0.5rem;
  row-gap: 0.5rem;
`;

export const MediaIcon = styled.div`
  ${({ theme }) => css`
    display: flex;
    background-color: ${theme.colors.primary};
    border-radius: 1rem;
    position: relative;
    padding: 0.5rem;
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 2rem;
    height: 2rem;
    border-radius: 100%;
    cursor: pointer;
    color: ${theme.colors.white};
    transition: all ${theme.transitions.short};

    &:hover {
      transform: scale(1.0625);
      background-color: ${theme.colors.dark};
    }
  `}
`;

export const MediaShareIcon = styled(MediaIcon)`
  margin: 0;
  color: ${({ theme }) => theme.colors.white};
`;
